module.exports = __webpack_public_path__ + "static/img/img3.77663e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/img3.png
// module id = mJEu
// module chunks = 1